export const NavBar_utils = [
  {id: 1, title: 'Главная', path: '/'},
  {id: 2, title: 'Автомобили', path: '/cars'},
  {id: 3, title: 'FAQ', path: '/faq'},
  {id: 4, title: 'Условия аренды', path: '/rent'},
  {id: 5, title: 'Контакты', path: '/contacts'},
]

